import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'

import title_pc from '../../../assets/images/content-play/title-pc.png'
import title_mb from '../../../assets/images/content-play/title-mb.png'
import icon_hand from '../../../assets/images/content-play/icon-hand.png'

import icon_logo_dis from '../../../assets/images/content-play/icon-logo-dis.png'
import icon_pubertad_dis from '../../../assets/images/content-play/icon-pubertad-dis.png'
import icon_zonav_dis from '../../../assets/images/content-play/icon-zonav-dis.png'
import icon_menstruacion_dis from '../../../assets/images/content-play/icon-menstruacion-dis.png'

import icon_logo_act from '../../../assets/images/content-play/icon-logo-act.png'
import icon_pubertad_act from '../../../assets/images/content-play/icon-pubertad-act.png'
import icon_zonav_act from '../../../assets/images/content-play/icon-zonav-act.png'
import icon_menstruacion_act from '../../../assets/images/content-play/icon-menstruacion-act.png'

import useMediaQuery from '../../../utils/useMediaQuery'

import { Context } from '../../../context/app-context'
import userSessionStorage from '../../../utils/userSessionStorage'

import gameServices from '../../../services/game-service'
import { concourseId, gameId } from '../../../constants/activity-constants'

import Button from '../../atoms/button/button'
import Loader from 'react-loader-spinner'
import getUserInfo from '../../../utils/getUserInfo'

import { jsonToHash } from '../../../utils/crypto'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import './content-play.scss'
import {
  text_replica_content_play1,
  text_replica_content_play2,
  text_replica_content_play3,
} from './replica-content-play'

import { LOCALE } from '../../../constants/activity-constants'
const arg = LOCALE === 'es-AR'

const ContentPlay = () => {
  const isMobile = useMediaQuery()
  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)
  const userInfo = getUserInfo()

  const [activeUniverso, setActiveUniverso] = useState(false)
  const [firstParticipation, setFirstParticipation] = useState()
  const [firstPromotionalKey, setFirstPromotionalKey] = useState()

  const [isLoading, setIsLoading] = useState(true)
  const [lifesUser, setLifesUser] = useState()

  function getEdad(dateString) {
    let hoy = new Date()
    let fechaNacimiento = new Date(dateString)
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear()
    let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth()
    if (
      diferenciaMeses < 0 ||
      (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
    ) {
      edad--
    }
    return edad
  }

  useEffect(() => {
    const userInfo = session.getUserInfo()
    if (userInfo) {
      /* 
     
     ARA TODAS EDADES if (!canIPlayByMyEdad()) {
        return
      } */
      getAcumulationConcourse()
      getLifes()
    }
  }, [])

  const getLifes = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }

    gameServices.getLife(gameId, config).then(res => {
      if (res.status === 200) {
        setActiveUniverso(res.data.totalLives > 0 ? true : false)
        setLifesUser(res.data.totalLives)
        setIsLoading(false)
      }
    })
  }

  const getAcumulationConcourse = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    gameServices.getAcumulationConcourse(concourseId, config).then(res => {
      if (res.status === 200) {
        setFirstParticipation(res.data.participations)
        res.data.promotionalKeyUsed
          ? setFirstPromotionalKey(true)
          : setFirstPromotionalKey(false)
      }
    })
  }
  const canIPlayByMyEdad = () => {
    let edad = getEdad(session.getUserInfo().birthdate)
    // console.log('edad ======>', edad, session.getUserInfo())
    if (edad < 9 || edad > 19) {
      setTimeout(() => {
        dispatch({
          type: 'set-modal',
          modalActive: {
            type: 'sorry',
            props: {
              close: () => {
                dispatch({ type: 'clear-modal' })
                navigate('/')
              },
            },
          },
        })
      }, 500)
      navigate('/')
      return false
    }
    return true
  }
  const handleActivar = async () => {
    const userInfo = session.getUserInfo()
    pushEventData({
      event: 'Interacciones_Jugar_UCole',
      action: 'click',
      label: 'Activar',
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo?.name,
          apellido: userInfo?.lastName,
          celular: userInfo?.cellPhone,
          correo: userInfo?.email,
          ciudad: userInfo.location?.cityName,
          departamento: userInfo.location?.countryStateName,
          pais: userInfo?.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
    if (!userInfo) {
      dispatch({
        type: 'set-modal',
        modalActive: {
          type: 'login',
          props: {
            close: () => {
              dispatch({ type: 'clear-modal' })
              navigate('/')
            },
            handleSuccess: () => {
              window.location.reload()
            },
            // mobile: isMobile,
          },
        },
      })
      return
    }

    dispatch({
      type: 'set-modal',
      modalActive: {
        type: 'keys',
        props: {
          close: () => {
            dispatch({ type: 'clear-modal' })
            navigate('/')
          },
          firstKey: firstParticipation, // esta bandera me dice si es primera clave o no en el modal
          firstPromotionalKey: firstPromotionalKey, // esta bandera me dice si ya uso la promotional key
        },
      },
    })
  /*   let edad = getEdad(session.getUserInfo().birthdate)
    // console.log('edad ======>',edad, session.getUserInfo())
    if (edad >= 9 && edad <= 19) {
    } else {
      //console.log(edad)
      dispatch({
        type: 'set-modal',
        modalActive: {
          type: 'sorry',
          props: {
            close: () => {
              dispatch({ type: 'clear-modal' })
              navigate('/')
            },
          },
        },
      })
    } */
  }

  const handleDataLayer = async label => {
    const userInfo = session.getUserInfo()
    pushEventData({
      event: 'Interacciones_Jugar_UCole',
      label: label,
      user_data: userInfo && [
        await jsonToHash({
          nombre: userInfo?.name,
          apellido: userInfo?.lastName,
          celular: userInfo?.cellPhone,
          correo: userInfo?.email,
          ciudad: userInfo.location?.cityName,
          departamento: userInfo.location?.countryStateName,
          pais: userInfo?.countryName,
        }),
      ],
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  const handleAction = (goTo, label) => {
    handleDataLayer(label)
    navigate(goTo)
  }

  const planets = [
    {
      dis: icon_pubertad_dis,
      act: icon_pubertad_act,
      className: 'icon-pubertad',
      action: () => handleAction('/tetris', 'Jugar - Planeta Pubertad'),
    },
    {
      dis: icon_zonav_dis,
      act: icon_zonav_act,
      className: 'icon-zonav',
      action: () => handleAction('/linea3', 'Jugar - Planeta Zona V'),
    },
    {
      dis: icon_menstruacion_dis,
      act: icon_menstruacion_act,
      className: 'icon-menstruacion',
      action: () => handleAction('/snake', 'Jugar - Planeta Menstruacion'),
    },
  ]

  return (
    <div className="f-content-play-container">
      <section className="f-content-play-left">
        {session.getUserInfo() && (
          <h2 className="f-content-play-left__nameUser">
            ¡Hola <span>{userInfo?.name}!</span>
          </h2>
        )}
        <img
          src={isMobile ? title_mb : title_pc}
          alt="titulo de la seccion de jugar"
          className="f-content-play-left__img-title"
        />
        <span className="f-content-play-left__container-info">
          {activeUniverso ? (
            <p className="f-activeUniverso-p">{text_replica_content_play2}</p>
          ) : session.getUserInfo() ? (
            <p>{text_replica_content_play3}</p>
          ) : (
            <p className={`${arg && 'text-positon-arg'}`}>
              {text_replica_content_play1}
            </p>
          )}
          {activeUniverso ? (
            <img
              src={icon_hand}
              alt="icono demostracion de click"
              className="f-content-play-left__container-info__icon-hand"
            />
          ) : (
            <Button
              className={`f-button-play ${arg && '--arg'}`}
              onClick={() => handleActivar()}
            >
              ¡Comenzar!
            </Button>
          )}
        </span>
        {session.getUserInfo() && (
          <h2 className="f-content-play-left__lifesUser">
            {arg ? 'Tenés' : 'Tienes'}{' '}
            <span>
              {' '}
              {isLoading ? (
                <Loader type="Oval" color="#ffffff" height={20} width={20} />
              ) : (
                lifesUser
              )}{' '}
              vidas
            </span>
          </h2>
        )}
      </section>
      <section className="f-content-play-right">
        <img
          src={activeUniverso ? icon_logo_act : icon_logo_dis}
          alt="logo actividad desactivado"
          className="f-content-play-right__icon-logo"
        />
        {planets.map((planet, index) => {
          return (
            <div
              className={`f-content-play-right__containerPlanet-${planet.className}`}
              key={index}
            >
              <img
                src={activeUniverso ? planet.act : planet.dis}
                alt={`${planet.className} actividad desactivado`}
              />
              {activeUniverso && (
                <Button className="f-button-planets" onClick={planet.action}>
                  Jugar
                </Button>
              )}
            </div>
          )
        })}
      </section>
    </div>
  )
}

export default ContentPlay
